
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { formatDuration } from '@/utils/dateUtils';

interface SupervisionSummaryProps {
  totalHours: number;
  supervisionCount: number;
}

export const SupervisionSummary: React.FC<SupervisionSummaryProps> = ({
  totalHours,
  supervisionCount
}) => {
  // Convert totalHours to a more presentable format (from minutes to hours)
  const displayHours = typeof totalHours === 'number' ? (totalHours / 60).toFixed(1) : '0.0';
  
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-medium">Supervision Progress</CardTitle>
        <CardDescription>Track your coaching supervision</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-1 text-center">
            <p className="text-sm text-muted-foreground">Total Sessions</p>
            <p className="text-2xl font-bold">{supervisionCount}</p>
          </div>
          <div className="space-y-1 text-center">
            <p className="text-sm text-muted-foreground">Total Hours</p>
            <p className="text-2xl font-bold">{displayHours}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
